



















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Public } from '@/http/api_Public'; 
import 'swiper/dist/css/swiper.css'
@Component({ 
    components: {}, 
})
export default class banner extends Vue {
  
    public $refs!: {
        
    };
    activeName=1;
    swiperOption={
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        // //循环
        loop:true,
        //每张播放时长3秒，自动播放
        autoplay:{
            delay:3000,
            disableOnInteraction: false,
        },    
    }
    // handleClick(val){
        
    //     this.activeName=val;
     
    //     this.$refs.mySwiper.swiper.slideTo(val, 1000, false);
    // }

    // slideChange(){
    //     let index = this.$refs.mySwiper['swiper'].activeIndex==4?1:this.$refs.mySwiper['swiper'].activeIndex;
    //     // console.log(index);
    //     if(index ==0) {
    //         this.activeName = 3
    //         return
    //     }
    //     this.activeName = index
    // }
    
   
    async mounted() {
        
    }
    async created() {
    }

    goPage(tag){
        switch (tag) {
            case 1:
                this.$router.push(`/home2`);
                break;
            case 2:
                // this.$router.push(`/login`);
                break;

            default:
                break;
        }
    }
  
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/banner.vue